import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.094 6.5h7.437c.41 0 .82.273.985.656.164.41.109.875-.192 1.176l-2.761 3.09v4.703a.85.85 0 0 1-.493.793.94.94 0 0 1-.93-.082l-1.75-1.313c-.218-.164-.328-.41-.328-.71v-3.391l-2.789-3.09c-.3-.328-.355-.766-.191-1.176A1.12 1.12 0 0 1 6.094 6.5m8.531 8.75h3.5a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875h-3.5a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875m-.875-3.5c0-.465.383-.875.875-.875h3.5a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875h-3.5a.864.864 0 0 1-.875-.875m2.625-5.25h1.75a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875h-1.75a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875"
    }, null, -1)
  ]))]))
}
export default { render: render }